/**
 * 对 try-catch 语句的封装
 * @param asyncFn 异步方法
 * @param params 对应参数
 */
export default async function tryCatch<T>(
    asyncFn: (params?: any) => Promise<T | null>,
    params?: any
): Promise<[Error | null, T | null]> {
    let [err, result]: [Error | null, T | null] = [null, null];
    try {
        result = await asyncFn(params);
    } catch (e) {
        err = e;
    }
    return [err, result];
}
